import React, { useEffect, useState } from 'react'
import {
  Modal,
} from 'antd'
import { unwrapResult } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import styles from './appllication.module.css'
import { getCopyDetailAsync } from './chainSlice'
import { EditableList } from '../../compnents/list/EditableList'
import {  CopyDetailColumns, CopyDetailYSYWColumns } from './columns'
import { Category } from '../../models/category'

export const CGDDetailModal = (props: {
  visible: boolean
  category: string
  onOk: () => void
  onCancel: () => void
  storehouseTag: any
  inventoryReceiptsId?:any
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [page, setPage] = useState<any>({
    items: [
    ],
    total: 0,
  })

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  useEffect(() => {
    if (props?.visible){
      dispatch(getCopyDetailAsync({ inventoryReceiptsId:props?.inventoryReceiptsId, qurryBranchData: true }))
      .then(unwrapResult)
      .then((res: any) => {
        const data = {
          total: res?.length,
          items: res,
        }
        setPage(data)
      })
    }else{
      setPage([])
    }
  }, [props?.visible])

  return (
    <Modal
      title='采购单详情'
      width={1200}
      visible={props?.visible}
      className={styles.copyTBDModal}
      onCancel={() => {
        props?.onCancel()
      }}
      footer={null}
      centered
    >
      <div>
        <EditableList
          style={{ height:'450px', overflow: 'auto' }}
          scroll={{ x: '30rem' }}
          page={{
            items: page.items,
            current: params.current,
            size: params.size,
            total: page.total,
          }}
          pagination={false}
          rowKey={(m: any) => m.id}
          columns={props.category == Category.CGYW ? CopyDetailColumns(
            params.size * (params.current - 1),
            props?.storehouseTag
          ) : CopyDetailYSYWColumns(params.size * (params.current - 1))}
          sticky
        />
      </div>
    </Modal>
  )
}
